import { render, staticRenderFns } from "./agent-transactions.vue?vue&type=template&id=54e4c6a7&"
import script from "./agent-transactions.vue?vue&type=script&lang=js&"
export * from "./agent-transactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports